import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import EmailBrandingLinks, {
  type EmailBrandingLinksProps
} from "./email-branding-links.component";
import { useEmailBranding } from "./use-email-branding.hook";

interface EmailBrandingBannerProps extends EmailBrandingLinksProps {
  /** One sentence each, read top to bottom. */
  lines: string[];
}

/**
 * The blue banner that tells staff what branding an email gets. Admins get "Edit email branding",
 * everyone else is told who can change it, so nobody is left with a setting they cannot find.
 */
export default function EmailBrandingBanner({
  lines,
  getPreviewRequest,
  zIndex
}: EmailBrandingBannerProps) {
  const { canEdit } = useEmailBranding();

  return (
    <Alert severity="info" data-testid="email-branding-banner">
      <Stack gap={0.75}>
        {lines.map((line) => (
          <Typography key={line} variant="body2" color="inherit">
            {line}
          </Typography>
        ))}
        <Stack
          direction="row"
          alignItems="center"
          flexWrap="wrap"
          columnGap={1}
          sx={{ ml: getPreviewRequest || canEdit ? -0.625 : 0 }}
        >
          <EmailBrandingLinks
            getPreviewRequest={getPreviewRequest}
            zIndex={zIndex}
          />
          {!canEdit && (
            <Typography variant="body2" color="inherit" fontWeight={700}>
              A practice admin can change these settings.
            </Typography>
          )}
        </Stack>
      </Stack>
    </Alert>
  );
}
